import { Component } from '@angular/core';

@Component({
  selector: 'app-enhance',
  templateUrl: './enhance.component.html',
  styleUrls: ['./enhance.component.scss']
})
export class EnhanceComponent {

}
